import { render, staticRenderFns } from "./GiftSubscriptionCard.vue?vue&type=template&id=2e95b810&scoped=true&"
import script from "./GiftSubscriptionCard.vue?vue&type=script&lang=js&"
export * from "./GiftSubscriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./GiftSubscriptionCard.vue?vue&type=style&index=0&id=2e95b810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e95b810",
  null
  
)

export default component.exports